import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.1415 2C10.6487 2 11.1165 2.26786 11.3737 2.70714L19.088 15.85C19.3487 16.2929 19.3487 16.8393 19.0951 17.2821C18.8415 17.725 18.3665 18 17.8558 18H2.42725C1.91654 18 1.44154 17.725 1.18797 17.2821C0.934396 16.8393 0.937968 16.2893 1.19511 15.85L8.9094 2.70714C9.16654 2.26786 9.6344 2 10.1415 2ZM10.1415 6.57143C9.66654 6.57143 9.2844 6.95357 9.2844 7.42857V11.4286C9.2844 11.9036 9.66654 12.2857 10.1415 12.2857C10.6165 12.2857 10.9987 11.9036 10.9987 11.4286V7.42857C10.9987 6.95357 10.6165 6.57143 10.1415 6.57143ZM11.2844 14.5714C11.2844 14.2683 11.164 13.9776 10.9497 13.7633C10.7353 13.549 10.4446 13.4286 10.1415 13.4286C9.83843 13.4286 9.54774 13.549 9.33342 13.7633C9.11909 13.9776 8.99868 14.2683 8.99868 14.5714C8.99868 14.8745 9.11909 15.1652 9.33342 15.3796C9.54774 15.5939 9.83843 15.7143 10.1415 15.7143C10.4446 15.7143 10.7353 15.5939 10.9497 15.3796C11.164 15.1652 11.2844 14.8745 11.2844 14.5714Z",
		fill: "#0D2976"
	})
});
export default SvgWarning;
